import React from 'react';
import { LegacyGrid as Grid } from '../../elements';
import Skeleton from '@mui/material/Skeleton';
import css from './DigitalTwinView.module.css';

export const DigitalTwinSkeleton: React.FC = () => {
  return (
    <div className={css.skeletonRoot}>
      <div className={css.skeletonHeader}>
        <Skeleton width={100} height={12} style={{ marginBottom: 10 }} />
        <Skeleton width={260} height={26} style={{ marginBottom: 8 }} />
        <Skeleton width={340} height={14} />
      </div>
      <div className={css.skeletonSection}>
        <Skeleton width={140} height={12} style={{ marginBottom: 12 }} />
        <Skeleton variant="rectangular" height={120} style={{ borderRadius: 10 }} />
      </div>
      <div className={css.skeletonSection}>
        <Skeleton width={120} height={12} style={{ marginBottom: 12 }} />
        <Grid container spacing={2}>
          {[1, 2, 3].map((i) => (
            <Grid item xs={12} sm={4} key={i}>
              <Skeleton variant="rectangular" height={130} style={{ borderRadius: 10 }} />
            </Grid>
          ))}
        </Grid>
      </div>
      <div className={css.skeletonSection}>
        <Skeleton variant="rectangular" height={140} style={{ borderRadius: 10 }} />
      </div>
      <Skeleton variant="rectangular" height={300} style={{ borderRadius: 10 }} />
    </div>
  );
};
